import React, { useState } from 'react';
import Select from 'react-select';
import './AdvancedMenu.css';
import { randomHex, lightOrDark } from '../utility/Element.js';
import { TagCloud } from 'react-tagcloud';
import { 
  getBadges,
  getMainTags,
  getMainIngredients,
  getMainCredits
} from '../model/recipe/recipeSlice';
import { 
  getSearchFilter,
  getSearchTextFilter
} from '../model/searchFilter/searchFilterSlice';
import { useSelector } from 'react-redux';

const AdvancedMenu = (props) => {
	const themeState = props.tema;
	const filterTagRef = React.createRef();
	const callback = props.callback;
	const [filteredTags, setFilteredTags] = useState([...useSelector(getMainTags)]);
	const [selectedIngr, setSelectedIngr] = useState([]);
	const [selectedBadge, setSelectedBadge] = useState([]);
	const [selectedCredits, setSelectedCredits] = useState([]);
	const [menuOpen] = useState(undefined);
	const [selectedFilter] = useState({...useSelector(getSearchFilter) });
	const ingredients = useSelector(getMainIngredients);
	const [tags, setTags] = useState([...useSelector(getMainTags)]);
	const [selectedFilterText] = useState(useSelector(getSearchTextFilter))
	const badges = useSelector(getBadges);
	const credits = useSelector(getMainCredits);
	React.useEffect(() => {
		document.getElementById("closeMenuButton").addEventListener("click", function () {
			document.getElementsByTagName("header")[0].classList.toggle("nav_is_visible");
			document.getElementsByTagName("main")[0].classList.toggle("nav_is_visible");
			(document.getElementById("advancedMenu").style.transform === "none") ? document.getElementById("advancedMenu").style.transform = "translateX(-150%)" : document.getElementById("advancedMenu").style.transform = "none";
			this.classList.toggle("active");
		});
		onRestoreFilter();
	},[selectedFilter]);
	const handleChangeFilterTag = (e) => {
		var fTags = tags.filter((t) => t.value.toLowerCase().includes(e.target.value?.toLowerCase()));
		setFilteredTags(fTags);
	};
	const onIngredientsChange = (options) => {
		const ings = options.map((option) => {
			return option.value.id;
		});
		selectedFilter.ingredients = ings;
		
		setSelectedIngr(options)
		callback(selectedFilter);
	}
	const onExternalBadgeSelection = (badge, reset) => {
		const index = selectedBadge.findIndex((b) => b.value === badge.value);
		badge.retrieved = true;
		if (reset) {
			resetFilter();
			onBadgesChange([badge]);
		} else {
			if (index === -1) {
				selectedBadge.push(badge);
			} else {
				selectedBadge.splice(index, 1);
			}
			onBadgesChange([...selectedBadge]);
		}
	}
	const onExternalCreditChange = (credit) => {
		const index = selectedCredits.findIndex((c) => c.value === credit.value);
		if (index === -1) {
			selectedCredits.push(credit);
		} else {
			selectedCredits.splice(index, 1);
		}
		onCreditsChange([...selectedCredits]);
	}
	const onCreditsChange = (credits) => {
		const crts = credits.map((credit) => {
			return credit.value;
		});
		selectedFilter.credits = crts;
		setSelectedCredits(credits);
		
		callback(selectedFilter);
	}
	const onBadgesChange = (badge) => {
		const bdgs = badge.map(b => b.value);
		selectedFilter.badges = bdgs;
		setSelectedBadge(badge);
		callback(selectedFilter);
	}
	const onTagsChange = (tag) => {
		tag.selected = !tag.selected;
		const selectedTags = [];
		const newTags = tags.map((ele) => {
			if (ele.value === tag.value) {
				ele.selected = tag.selected;
				ele.props = {
					style: {
						cursor: 'pointer',
						backgroundColor: tag.selected ? ele.props.style.color : 'unset',
						color: tag.selected ? lightOrDark(ele.props.style.color) : ele.props.style.backgroundColor,
					},
				};
			}
			if (ele.selected) {
				selectedTags.push(ele.value);
			}
			return ele;
		});

		setTags(newTags);
		setFilteredTags([...newTags]);

		
		selectedFilter.tags = selectedTags;
		callback(selectedFilter);
	}

	const restoreFilter = () => {
//		Restore badges
		if (selectedFilter.badges && selectedFilter.badges.length > 0) {
			var badgesInner = badges.filter((b) => {return selectedFilter.badges.indexOf(b.value) > -1});
			setSelectedBadge(badgesInner);
		}

//		Restore ingredients
		if (selectedFilter.ingredients && selectedFilter.ingredients.length > 0) {
			var ingsInner = ingredients.filter((i) => {
				return selectedFilter.ingredients.indexOf(i.label.replaceAll(' ', '-')) > -1
			});
			setSelectedIngr(ingsInner);
		}
//		Restore tags
		if (selectedFilter.tags && selectedFilter.tags.length > 0) {
			const tagsInner = tags.map((ele) => {
				var selezionato = selectedFilter.tags.indexOf(ele.value) > -1;
				if (selezionato) {
					ele.selected = true;
					ele.props = {
						style: {
							cursor: 'pointer',
							backgroundColor: themeState ? randomHex('white') : randomHex('black'),
							color: themeState ? 'white' : 'black',
						},
					};
				} else {
					ele.props = {
						style: {
						cursor: 'pointer',
						color: themeState ? randomHex('white') : randomHex('black'),
						}
					}
				}
				return ele;
			});
			setTags(tagsInner);
			setFilteredTags(tagsInner);
		}
//		Restore credits
		if (selectedFilter.credits && selectedFilter.credits.length > 0) {
			var creditsInner = credits.filter((c) => {return selectedFilter.credits.indexOf(c.value) > -1});
			setSelectedCredits(creditsInner);
		}
	}

	const resetFilter = () => {
		tags.filter((t) => t.selected).forEach((t) => onTagsChange(t));
		selectedFilter.badges = [];
		selectedFilter.credits = [];
		selectedFilter.ingredients = [];
		filterTagRef.current.value = '';
		window.excludedFilterView = {
			"ingredients": [], 
			"tags": [], 
			"badges": [],
			"credits": [],
		}

		setSelectedIngr([]);
		setSelectedBadge([]);
		setSelectedCredits([]);
		setFilteredTags(tags);
		;
	}
	const onRestoreFilter = () => {
		restoreFilter();
		callback(selectedFilter, selectedFilterText, "restore");
	}
	const onResetFilter = () => {
		resetFilter();
		callback(selectedFilter);
	}
  window["resetFilter"] = onResetFilter;
  window["tagsChange"] = onTagsChange;
  window["ingredientsChange"] = onIngredientsChange;
  window["badgesChange"] = onExternalBadgeSelection;
  window["creditChange"] = onExternalCreditChange;
  const matchMedia = window.matchMedia('only screen and (max-width: 1000px)').matches;
  const minSize = matchMedia ? 40 : 15;
  const maxSize = matchMedia ? 90 : 45;
  const labelChiudi = selectedFilter.ingredients?.length >0 || selectedFilter.tags?.length >0 || selectedFilter.badges?.length >0 || selectedFilter.credits?.length >0 ? "Cerca": "Chiudi";
return ([
			<div key="1" id="advancedMenu" className='menu unselectable'>
				<h1>Ricerca avanzata</h1>
				<button className="btn close-menu" id="closeMenuButton"><i className="fa fa-times" aria-hidden="true"></i></button>
	  		<label id="ingredientsLabel" htmlFor="ingredients">Ingredienti:</label>
	      <Select id="ingredients"
	      	value={selectedIngr}
		      aria-labelledby="ingredientsLabel"
	      	aria-label="Ingredienti"
	      	aria-sort="ascending"
	        options={ingredients}
	        autoFocus
	        blurInputOnSelect
	        captureMenuScroll
	        closeMenuOnSelect
	        isMulti
	        isSearchable
	        className="simple-select"
					classNamePrefix="simple-select"
	        onChange={onIngredientsChange}
	        noOptionsMessage={() => "Nessun ingrediente"}
	        placeholder="Seleziona gli ingredienti.."
	      />

        <label id="badgesLabel" htmlFor="badges">Badges:</label>
        <Select id="badges"
        	value={selectedBadge}
          aria-labelledby="badgesLabel"
          aria-label="Basges"
          options={badges}
          autoFocus
          blurInputOnSelect
          captureMenuScroll
          closeMenuOnSelect
          isMulti
          menuIsOpen={menuOpen}
          isSearchable
          className="badge-select"
          classNamePrefix="badge-select"
          formatOptionLabel={(badge) => (
            <div className="badge-selector" id="badgesUL">
              <div className="badge-img-select"><img src={`/images/badges/${badge.value}.png`} alt={badge.value} /></div>
              <div className="badge-label">{badge.label}</div>
            </div>
          )}
          onChange={onBadgesChange}
          noOptionsMessage={() => "Nessun badge"}
          placeholder="Seleziona i badge.."
        />
        <label id="creditsLabel" htmlFor="credits">Autori:</label>
        <Select id="credits"
			    value={selectedCredits}
          aria-labelledby="creditsLabel"
          aria-label="Credits"
          options={credits}
          autoFocus
          blurInputOnSelect
          captureMenuScroll
          closeMenuOnSelect
          isMulti
          menuIsOpen={menuOpen}
          isSearchable
          className="simple-select"
          classNamePrefix="simple-select"
          formatOptionLabel={(credit) => (
              <span className="credits-label">{credit.value}</span>
          )}
          onChange={onCreditsChange}
          noOptionsMessage={() => "Niente da visualizzare"}
          placeholder="Seleziona.."
        />

  		<label id="tagsLabel" htmlFor="tags">Tags:</label>
		  <input ref={filterTagRef} id="filterTags" type="text" placeholder='Filtra i tag' className="tag-cloud-filter tag-cloud-advanced" onChange={handleChangeFilterTag}/>
	      <TagCloud id="tags"
	        minSize={minSize}
	        maxSize={maxSize}
	        tags={filteredTags}
	        shuffle={false}
	        disableRandomColor={false}
	        className="tag-cloud"
	        onClick={onTagsChange}
	      />
				<button className="btn btn-search" onClick={onResetFilter}>Reset</button>
				<button className="btn btn-search" onClick={()=>{
		document.getElementsByTagName("header")[0].classList.toggle("nav_is_visible");
		document.getElementsByTagName("main")[0].classList.toggle("nav_is_visible");
		(document.getElementById("advancedMenu").style.transform==="none")?document.getElementById("advancedMenu").style.transform="translateX(-150%)":document.getElementById("advancedMenu").style.transform="none";
				}}>{labelChiudi}</button>
			</div>, 
  ]);
}

export default AdvancedMenu;

